/*
 * HORANDO – Uhr am Handgelenk (Wrist Try-On)
 * Zeigt das Produktbild maßstabsgetreu an einem gezeichneten Handgelenk.
 * Maßstab: features.diameter (mm) + automatisch gemessene Gehäusebreite im Bild.
 * Keine Abhängigkeiten. Wird erst beim ersten Klick initialisiert.
 */
(function () {
  'use strict';
  if (window.HorandoTryOn) return;

  /* ---------- Texte (alle Shop-Sprachen) ---------- */
  var I18N = {
    de: { open: 'Am Handgelenk ansehen', title: 'Am Handgelenk', men: 'Herren', women: 'Damen', wrist: 'Handgelenkumfang', skin: 'Hautton', compare: 'Vergleich mit meiner Uhr', mm: 'mm', case: 'Gehäuse', fit: ['Dezent', 'Klassisch', 'Präsent', 'Markant'], fitLabel: 'Wirkung', hint: 'Maßstabsgetreu nach Gehäusedurchmesser. Handgelenk messen: Maßband direkt unterhalb des Handgelenkknochens.', close: 'Schließen', error: 'Für dieses Modell ist die Ansicht leider nicht verfügbar.' },
    en: { open: 'View on the wrist', title: 'On the wrist', men: 'Men', women: 'Women', wrist: 'Wrist size', skin: 'Skin tone', compare: 'Compare with my watch', mm: 'mm', case: 'Case', fit: ['Subtle', 'Classic', 'Present', 'Bold'], fitLabel: 'Look', hint: 'True to scale based on case diameter. Measure your wrist just below the wrist bone.', close: 'Close', error: 'This view is not available for this model.' },
    fr: { open: 'Voir au poignet', title: 'Au poignet', men: 'Homme', women: 'Femme', wrist: 'Tour de poignet', skin: 'Teint', compare: 'Comparer avec ma montre', mm: 'mm', case: 'Boîtier', fit: ['Discret', 'Classique', 'Présent', 'Affirmé'], fitLabel: 'Effet', hint: 'À l’échelle selon le diamètre du boîtier. Mesurez juste sous l’os du poignet.', close: 'Fermer', error: 'Cet affichage n’est pas disponible pour ce modèle.' },
    it: { open: 'Guarda al polso', title: 'Al polso', men: 'Uomo', women: 'Donna', wrist: 'Circonferenza polso', skin: 'Carnagione', compare: 'Confronta con il mio orologio', mm: 'mm', case: 'Cassa', fit: ['Discreto', 'Classico', 'Presente', 'Deciso'], fitLabel: 'Effetto', hint: 'In scala reale in base al diametro della cassa. Misura il polso appena sotto l’osso.', close: 'Chiudi', error: 'Vista non disponibile per questo modello.' },
    es: { open: 'Ver en la muñeca', title: 'En la muñeca', men: 'Hombre', women: 'Mujer', wrist: 'Contorno de muñeca', skin: 'Tono de piel', compare: 'Comparar con mi reloj', mm: 'mm', case: 'Caja', fit: ['Discreto', 'Clásico', 'Presente', 'Llamativo'], fitLabel: 'Efecto', hint: 'A escala según el diámetro de la caja. Mida justo debajo del hueso de la muñeca.', close: 'Cerrar', error: 'Vista no disponible para este modelo.' },
    pt: { open: 'Ver no pulso', title: 'No pulso', men: 'Homem', women: 'Mulher', wrist: 'Perímetro do pulso', skin: 'Tom de pele', compare: 'Comparar com o meu relógio', mm: 'mm', case: 'Caixa', fit: ['Discreto', 'Clássico', 'Presente', 'Marcante'], fitLabel: 'Efeito', hint: 'À escala com base no diâmetro da caixa. Meça logo abaixo do osso do pulso.', close: 'Fechar', error: 'Vista indisponível para este modelo.' },
    sv: { open: 'Se på handleden', title: 'På handleden', men: 'Herr', women: 'Dam', wrist: 'Handledsomkrets', skin: 'Hudton', compare: 'Jämför med min klocka', mm: 'mm', case: 'Boett', fit: ['Diskret', 'Klassisk', 'Tydlig', 'Markant'], fitLabel: 'Intryck', hint: 'Skalenlig efter boettens diameter. Mät precis nedanför handledsbenet.', close: 'Stäng', error: 'Vyn är inte tillgänglig för denna modell.' },
    hu: { open: 'Megtekintés a csuklón', title: 'A csuklón', men: 'Férfi', women: 'Női', wrist: 'Csuklókerület', skin: 'Bőrszín', compare: 'Összehasonlítás a saját órámmal', mm: 'mm', case: 'Tok', fit: ['Visszafogott', 'Klasszikus', 'Hangsúlyos', 'Markáns'], fitLabel: 'Hatás', hint: 'Méretarányos a tokátmérő alapján. Közvetlenül a csuklócsont alatt mérjen.', close: 'Bezárás', error: 'Ennél a modellnél a nézet nem érhető el.' },
    ru: { open: 'Посмотреть на запястье', title: 'На запястье', men: 'Мужские', women: 'Женские', wrist: 'Обхват запястья', skin: 'Тон кожи', compare: 'Сравнить с моими часами', mm: 'мм', case: 'Корпус', fit: ['Сдержанно', 'Классически', 'Заметно', 'Выразительно'], fitLabel: 'Вид', hint: 'В реальном масштабе по диаметру корпуса. Измеряйте чуть ниже косточки.', close: 'Закрыть', error: 'Для этой модели вид недоступен.' },
    uk: { open: 'Переглянути на зап’ясті', title: 'На зап’ясті', men: 'Чоловічі', women: 'Жіночі', wrist: 'Обхват зап’ястя', skin: 'Тон шкіри', compare: 'Порівняти з моїм годинником', mm: 'мм', case: 'Корпус', fit: ['Стримано', 'Класично', 'Помітно', 'Виразно'], fitLabel: 'Вигляд', hint: 'У реальному масштабі за діаметром корпусу. Вимірюйте трохи нижче кісточки.', close: 'Закрити', error: 'Для цієї моделі перегляд недоступний.' }
  };
  function lang() {
    var l = (document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
    return I18N[l] ? l : 'de';
  }
  var T = I18N[lang()];

  var SKINS = [
    { a: '#f6dcc8', b: '#d9b39a', c: '#b98d72' },
    { a: '#eccbad', b: '#cf9f7c', c: '#a87856' },
    { a: '#d6a882', b: '#b07f5a', c: '#86593a' },
    { a: '#a87553', b: '#835537', c: '#5e3a22' },
    { a: '#6e4a33', b: '#523422', c: '#352013' }
  ];

  /* ---------- Hilfen ---------- */
  function parseDiameter(v) {
    if (!v) return null;
    var m = String(v).replace(',', '.').match(/(\d+(?:\.\d+)?)/);
    if (!m) return null;
    var d = parseFloat(m[1]);
    return d >= 15 && d <= 60 ? d : null;
  }
  // Sichtbare Breite des Handgelenks von oben: anthropometrisch ca. 34 % des Umfangs
  // (17,5 cm Herren-Mittel -> ca. 60 mm, 15,5 cm Damen-Mittel -> ca. 53 mm)
  function wristWidthFromCirc(cMm) { return cMm * 0.343; }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }

  /* ---------- Bildanalyse: freistellen + Gehäusebreite messen ---------- */
  var cache = {};
  function analyse(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try { resolve(process(img)); } catch (e) { reject(e); }
      };
      img.onerror = reject;
      img.src = src;
    });
    return cache[src];
  }

  /* Löcher und schmale Schlitze in der Uhren-Silhouette schließen.
     Morphologisches Schließen der Maske (Radius ~1 % der Bildbreite), danach werden
     alle durchsichtigen Pixel im Inneren deckend gemacht und mit den Farben der
     angrenzenden Uhrenpixel aufgefüllt – so scheint nirgends Haut durch die Uhr. */
  function morph(src, W, H, r, dilate) {
    var tmp = new Uint8Array(W * H), out = new Uint8Array(W * H), x, y, k, v;
    for (y = 0; y < H; y++) {
      for (x = 0; x < W; x++) {
        v = dilate ? 0 : 1;
        for (k = -r; k <= r; k++) {
          var xx = x + k;
          var s = (xx < 0 || xx >= W) ? (dilate ? 0 : 0) : src[y * W + xx];
          if (dilate ? s : !s) { v = dilate ? 1 : 0; break; }
        }
        tmp[y * W + x] = v;
      }
    }
    for (x = 0; x < W; x++) {
      for (y = 0; y < H; y++) {
        v = dilate ? 0 : 1;
        for (k = -r; k <= r; k++) {
          var yy = y + k;
          var s2 = (yy < 0 || yy >= H) ? 0 : tmp[yy * W + x];
          if (dilate ? s2 : !s2) { v = dilate ? 1 : 0; break; }
        }
        out[y * W + x] = v;
      }
    }
    return out;
  }
  function closeHoles(d, bg, W, H, keepRGB) {
    var n = W * H, fg = new Uint8Array(n), i;
    for (i = 0; i < n; i++) fg[i] = bg[i] ? 0 : 1;
    var r = Math.max(3, Math.round(W * 0.011));
    var closed = morph(morph(fg, W, H, r, true), W, H, r, false);
    for (i = 0; i < n; i++) if (fg[i]) closed[i] = 1;

    // Kerben an den Bandkanten schließen: zwischen zwei Gliedern reicht der weiße
    // Hintergrund seitlich ins Band hinein, dort schien die Haut durch. Nur in Bandzeilen
    // (schmaler als das Gehäuse) und nur senkrecht kurze, oben und unten begrenzte Lücken –
    // Krone, Drücker und die Flächen neben den Bandanstößen bleiben unberührt.
    var rw = new Int32Array(H), maxRw = 0, yy, xx;
    for (yy = 0; yy < H; yy++) {
      var l0 = -1, r0 = -1;
      for (xx = 0; xx < W; xx++) if (closed[yy * W + xx]) { l0 = xx; break; }
      if (l0 < 0) continue;
      for (xx = W - 1; xx >= l0; xx--) if (closed[yy * W + xx]) { r0 = xx; break; }
      rw[yy] = r0 - l0 + 1; if (rw[yy] > maxRw) maxRw = rw[yy];
    }
    var gapMax = Math.max(6, Math.round(H * 0.045));
    for (xx = 0; xx < W; xx++) {
      var last = -1;
      for (yy = 0; yy < H; yy++) {
        if (!closed[yy * W + xx]) continue;
        if (last >= 0 && yy - last > 1 && yy - last - 1 <= gapMax) {
          for (var yf = last + 1; yf < yy; yf++) if (rw[yf] < maxRw * 0.85) closed[yf * W + xx] = 1;
        }
        last = yy;
      }
    }

    // Zeilenweise zwischen den Außenkanten auffüllen. Rechts sitzt die Krone,
    // deshalb wird die linke Kante an der Mittelachse gespiegelt.
    var Lr = new Int32Array(H).fill(-1), Rr = new Int32Array(H).fill(-1), y, x0, top = -1, bot = -1;
    for (y = 0; y < H; y++) {
      for (x0 = 0; x0 < W; x0++) if (closed[y * W + x0]) { Lr[y] = x0; break; }
      if (Lr[y] < 0) continue;
      for (x0 = W - 1; x0 >= 0; x0--) if (closed[y * W + x0]) { Rr[y] = x0; break; }
      if (top < 0) top = y; bot = y;
    }
    if (top >= 0) {
      var hh = bot - top + 1, mids = [];
      for (y = top + Math.round(hh * 0.03); y < top + Math.round(hh * 0.16); y++) if (Lr[y] >= 0) mids.push((Lr[y] + Rr[y]) / 2);
      for (y = bot - Math.round(hh * 0.16); y < bot - Math.round(hh * 0.03); y++) if (Lr[y] >= 0) mids.push((Lr[y] + Rr[y]) / 2);
      mids.sort(function (a, b) { return a - b; });
      var ax = mids.length ? mids[Math.floor(mids.length / 2)] : W / 2;
      for (y = top; y <= bot; y++) {
        if (Lr[y] < 0) continue;
        var xe = Math.min(Rr[y], Math.round(2 * ax - Lr[y]));
        for (x0 = Lr[y]; x0 <= xe; x0++) closed[y * W + x0] = 1;
      }
    }
    var inner = morph(closed, W, H, 1, false);       // äußerster Rand bleibt weich
    // aufzufüllende Pixel: innen, aber nicht voll deckend
    var need = new Uint8Array(n), queue = [], known = new Uint8Array(n);
    for (i = 0; i < n; i++) {
      if (inner[i] && d[i * 4 + 3] < 250) need[i] = 1;
      else if (d[i * 4 + 3] >= 250) known[i] = 1;
    }
    // Farbe aus Nachbarn ausbreiten (Ringweise von außen nach innen)
    var fill = new Float32Array(n * 3), frontier = [], queued = new Uint8Array(n);
    for (i = 0; i < n; i++) {
      if (!need[i]) continue;
      var x = i % W;
      if ((x > 0 && known[i - 1]) || (x < W - 1 && known[i + 1]) || (i >= W && known[i - W]) || (i < n - W && known[i + W])) { frontier.push(i); queued[i] = 1; }
    }
    var guard = 0;
    while (!keepRGB && frontier.length && guard++ < 4000) {
      var next = [], done = [];
      for (var f = 0; f < frontier.length; f++) {
        var p = frontier[f]; if (known[p]) continue;
        var px = p % W, sr = 0, sg = 0, sb = 0, c = 0;
        for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
          var qx = px + dx, q = p + dy * W + dx;
          if (qx < 0 || qx >= W || q < 0 || q >= n || !known[q]) continue;
          if (need[q]) { sr += fill[q * 3]; sg += fill[q * 3 + 1]; sb += fill[q * 3 + 2]; }
          else { sr += d[q * 4]; sg += d[q * 4 + 1]; sb += d[q * 4 + 2]; }
          c++;
        }
        if (!c) continue;
        fill[p * 3] = sr / c; fill[p * 3 + 1] = sg / c; fill[p * 3 + 2] = sb / c;
        done.push(p);
      }
      for (var j = 0; j < done.length; j++) known[done[j]] = 1;
      for (j = 0; j < done.length; j++) {
        var o = done[j], ox = o % W;
        var nbs = [ox > 0 ? o - 1 : -1, ox < W - 1 ? o + 1 : -1, o - W, o + W];
        for (var m = 0; m < 4; m++) { var t = nbs[m]; if (t >= 0 && t < n && need[t] && !known[t] && !queued[t]) { queued[t] = 1; next.push(t); } }
      }
      frontier = next;
    }
    // Pixel deckend machen, vorhandene Halbtransparenz über die Füllfarbe legen
    for (i = 0; i < n; i++) {
      if (!need[i]) continue;
      // Bild mit weißem Grund: dort stehen im Original die echten Fotofarben (Lücken
      // zwischen den Gliedern), die werden nur deckend gemacht – keine verschmierten Flecken
      if (keepRGB) { d[i * 4 + 3] = 255; bg[i] = 0; continue; }
      var a = d[i * 4 + 3] / 255;
      d[i * 4] = Math.round(d[i * 4] * a + fill[i * 3] * (1 - a));
      d[i * 4 + 1] = Math.round(d[i * 4 + 1] * a + fill[i * 3 + 1] * (1 - a));
      d[i * 4 + 2] = Math.round(d[i * 4 + 2] * a + fill[i * 3 + 2] * (1 - a));
      d[i * 4 + 3] = 255;
      bg[i] = 0;
    }
  }

  function process(img) {
    var maxW = 700, sc = Math.min(1, maxW / img.naturalWidth);
    var W = Math.round(img.naturalWidth * sc), H = Math.round(img.naturalHeight * sc);
    var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(img, 0, 0, W, H);
    var id = cx.getImageData(0, 0, W, H), d = id.data, n = W * H;

    // Hintergrund: transparent vorhanden? sonst Flood-Fill auf Weiß vom Rand aus
    var transparent = d[3] < 20 && d[(W - 1) * 4 + 3] < 20 && d[(n - 1) * 4 + 3] < 20;
    var bg = new Uint8Array(n);
    if (transparent) {
      // nur Transparenz, die mit dem Bildrand verbunden ist, ist Hintergrund –
      // eingeschlossene Löcher (z. B. zwischen den Bandanstößen) gehören zur Uhr
      var st = [];
      for (var tx = 0; tx < W; tx++) { st.push(tx, (H - 1) * W + tx); }
      for (var ty = 0; ty < H; ty++) { st.push(ty * W, ty * W + W - 1); }
      while (st.length) {
        var tp = st.pop();
        if (bg[tp] || d[tp * 4 + 3] >= 128) continue;
        bg[tp] = 1;
        var tpx = tp % W;
        if (tpx > 0) st.push(tp - 1);
        if (tpx < W - 1) st.push(tp + 1);
        if (tp >= W) st.push(tp - W);
        if (tp < n - W) st.push(tp + W);
      }
    } else {
      var isW = function (p) {
        var r = d[p * 4], g = d[p * 4 + 1], b = d[p * 4 + 2];
        var mn = Math.min(r, g, b), mx = Math.max(r, g, b);
        return mn > 228 && mx - mn < 22;
      };
      var stack = [];
      for (var x = 0; x < W; x++) { stack.push(x, (H - 1) * W + x); }
      for (var y = 0; y < H; y++) { stack.push(y * W, y * W + W - 1); }
      while (stack.length) {
        var p = stack.pop();
        if (bg[p] || !isW(p)) continue;
        bg[p] = 1;
        var px = p % W;
        if (px > 0) stack.push(p - 1);
        if (px < W - 1) stack.push(p + 1);
        if (p >= W) stack.push(p - W);
        if (p < n - W) stack.push(p + W);
      }
      // weiche Kante: Randpixel nahe Weiß teiltransparent
      for (var q = 0; q < n; q++) {
        if (bg[q]) { d[q * 4 + 3] = 0; continue; }
        var qx = q % W;
        var nb = (qx > 0 && bg[q - 1]) || (qx < W - 1 && bg[q + 1]) || (q >= W && bg[q - W]) || (q < n - W && bg[q + W]);
        if (nb) {
          var m2 = Math.min(d[q * 4], d[q * 4 + 1], d[q * 4 + 2]);
          d[q * 4 + 3] = Math.max(60, Math.min(255, Math.round((255 - m2) * 6)));
        }
      }
      cx.putImageData(id, 0, 0);
    }

    closeHoles(d, bg, W, H, !transparent);
    cx.putImageData(id, 0, 0);

    // Zeilenweise linke/rechte Kante
    var L = new Int32Array(H).fill(-1), R = new Int32Array(H).fill(-1);
    var top = -1, bot = -1, minX = W, maxX = 0;
    for (var yy = 0; yy < H; yy++) {
      var row = yy * W, l = -1, r = -1;
      for (var xx = 0; xx < W; xx++) if (!bg[row + xx]) { l = xx; break; }
      if (l < 0) continue;
      for (var xr = W - 1; xr >= 0; xr--) if (!bg[row + xr]) { r = xr; break; }
      L[yy] = l; R[yy] = r;
      if (top < 0) top = yy; bot = yy;
      if (l < minX) minX = l; if (r > maxX) maxX = r;
    }
    if (top < 0) throw new Error('leer');
    var h = bot - top + 1;

    // Mittelachse aus den Bandbereichen oben/unten (ohne Krone)
    var mids = [];
    function band(a, b) { for (var yb = a; yb < b; yb++) if (L[yb] >= 0) mids.push((L[yb] + R[yb]) / 2); }
    band(top + Math.round(h * 0.03), top + Math.round(h * 0.16));
    band(bot - Math.round(h * 0.16), bot - Math.round(h * 0.03));
    mids.sort(function (a, b) { return a - b; });
    var axis = mids.length ? mids[Math.floor(mids.length / 2)] : (minX + maxX) / 2;

    // Gehäuse = größte halbe Breite; je Zeile zählt die schmalere Seite, weil Krone,
    // Drücker und Heliumventil nur einseitig vorstehen (sonst rutscht die Uhr aus der Mitte)
    var halfs = [];
    for (var yh = top; yh <= bot; yh++) if (L[yh] >= 0) halfs.push({ y: yh, v: Math.min(axis - L[yh], R[yh] - axis) });
    var sorted = halfs.map(function (o) { return o.v; }).sort(function (a, b) { return b - a; });
    var half = sorted[Math.min(sorted.length - 1, Math.round(sorted.length * 0.01))];
    var ys = halfs.filter(function (o) { return o.v >= half * 0.97; }).map(function (o) { return o.y; });
    var caseCy = ys.reduce(function (s, v) { return s + v; }, 0) / ys.length;

    // Ausschnitt
    var pad = 4, ox = Math.max(0, minX - pad), oy = Math.max(0, top - pad);
    var cw = Math.min(W, maxX + pad) - ox, ch = Math.min(H, bot + pad) - oy;
    var out = document.createElement('canvas'); out.width = cw; out.height = ch;
    out.getContext('2d').drawImage(cv, ox, oy, cw, ch, 0, 0, cw, ch);
    return {
      url: out.toDataURL('image/png'),
      w: cw, h: ch,
      casePx: half * 2,
      axisX: axis - ox,
      caseY: caseCy - oy
    };
  }

  /* ---------- Handgelenk als SVG ---------- */
  function smooth(pts) {
    // Catmull-Rom -> Bezier
    var s = 'M' + pts[0][0] + ',' + pts[0][1];
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      s += ' C' + (p1[0] + (p2[0] - p0[0]) / 6) + ',' + (p1[1] + (p2[1] - p0[1]) / 6) + ' ' +
        (p2[0] - (p3[0] - p1[0]) / 6) + ',' + (p2[1] - (p3[1] - p1[1]) / 6) + ' ' + p2[0] + ',' + p2[1];
    }
    return s;
  }

  // Szene in mm, Arm horizontal, Hand rechts (linkes Handgelenk, Handrücken oben)
  var SCENE_W = 230, SCENE_H = 150, WX = 132, CY = 75;

  function armPaths(w, female) {
    var F = w * (female ? 1.24 : 1.32);       // Unterarm
    var H = w * (female ? 1.14 : 1.2);        // Hand
    // oben = Kleinfingerseite (Elle), unten = Daumenseite
    var top = [
      [-20, CY - F * 0.5], [40, CY - F * 0.485], [WX - 55, CY - w * 0.6], [WX - 20, CY - w * 0.52],
      [WX - 6, CY - w * 0.515], [WX + 4, CY - w * 0.505], [WX + 22, CY - w * 0.53], [WX + 55, CY - H * 0.52],
      [WX + 90, CY - H * 0.53], [SCENE_W + 20, CY - H * 0.5]
    ];
    var bot = [
      [SCENE_W + 20, CY + H * 0.5], [WX + 92, CY + H * 0.52], [WX + 62, CY + H * 0.54],
      [WX + 34, CY + w * 0.55], [WX + 12, CY + w * 0.5], [WX - 6, CY + w * 0.49], [WX - 30, CY + w * 0.54],
      [WX - 70, CY + F * 0.47], [40, CY + F * 0.49], [-20, CY + F * 0.5]
    ];
    var outline = smooth(top) + ' L' + bot[0][0] + ',' + bot[0][1] + smooth(bot).replace(/^M[^C]*/, '') + ' Z';
    return { outline: outline, F: F, H: H };
  }

  /* ---------- Modal ---------- */
  var state = { female: false, circ: 175, skin: 1, compare: '' };
  var root, data, info;

  function css() {
    if (document.getElementById('hti-css')) return;
    var s = el('style', { id: 'hti-css' });
    s.textContent =
      '.hti-btn{display:inline-flex;align-items:center;gap:8px;margin:12px 0 0;padding:10px 16px;border:1px solid #141414;background:#fff;color:#141414;font-family:"DM Sans",sans-serif;font-size:13px;font-weight:500;text-transform:uppercase;letter-spacing:.06em;cursor:pointer;border-radius:2px}' +
      '.hti-btn:hover{background:#141414;color:#fff}.hti-btn svg{width:18px;height:18px}' +
      '.hti-btn--overlay{position:absolute;left:12px;top:12px;z-index:5;margin:0;padding:8px 12px;font-size:12px;background:rgba(255,255,255,.94)}' +
      '.hti-btn .hti-s{display:none}' +
      '.hti-btn--overlay{gap:6px;padding:6px 10px;font-size:11px;letter-spacing:.05em;line-height:1.2}.hti-btn--overlay svg{width:15px;height:15px}.hti-btn--overlay .hti-l{display:none}.hti-btn--overlay .hti-s{display:inline}' +
      '@media(max-width:749px){.hti-btn--overlay{left:8px;top:8px;gap:5px;padding:5px 9px;font-size:10.5px;letter-spacing:.05em;line-height:1.2}.hti-btn--overlay svg{width:14px;height:14px}.hti-btn--overlay .hti-l{display:none}.hti-btn--overlay .hti-s{display:inline}}' +
      '.hti-ov{position:fixed;left:0;right:0;top:0;bottom:0;height:100vh;height:100dvh;z-index:2147483000;background:rgba(17,17,17,.55);display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box}' +
      '.hti-box{background:#fff;color:#111;width:min(920px,100%);max-height:100%;overflow:auto;border-radius:2px;box-shadow:0 20px 60px rgba(0,0,0,.25);font-family:inherit}' +
      '.hti-head{position:sticky;top:0;z-index:3;background:#fff;display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-bottom:1px solid #eee}' +
      '.hti-head h3{margin:0;font-family:"DM Sans",sans-serif;font-size:20px;font-weight:500;text-transform:uppercase;letter-spacing:.02em;color:#141414}.hti-head small{display:block;color:#7a7a75;font-family:"IBM Plex Sans",sans-serif;font-weight:400;font-size:13px;text-transform:none;letter-spacing:0;margin-top:4px}' +
      '.hti-x{background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#111;padding:4px 8px}' +
      '.hti-body{display:grid;grid-template-columns:1fr 280px;gap:0}' +
      '.hti-stage{background:#f5f5f5;position:relative;min-height:240px}' +
      '.hti-stage svg{display:block;width:100%;height:auto}' +
      '.hti-badge{position:absolute;left:14px;bottom:12px;background:#fff;padding:6px 10px;font-size:12.5px;border-radius:2px;color:#141414}' +
      '.hti-ctl{padding:18px 20px;display:flex;flex-direction:column;gap:18px;font-size:14px}' +
      '.hti-lbl{display:flex;justify-content:space-between;font-family:"DM Sans",sans-serif;font-weight:500;margin-bottom:8px;font-size:11px;text-transform:uppercase;letter-spacing:.08em;color:#141414}' +
      '.hti-lbl span:nth-child(2){font-family:"IBM Plex Sans",sans-serif;font-size:13px;font-weight:400;text-transform:none;letter-spacing:0}' +
      '.hti-seg{display:grid;grid-template-columns:1fr 1fr;border:1px solid #141414;border-radius:2px;overflow:hidden}.hti-seg button{background:#fff;color:#141414;border:0;padding:9px;font-family:"DM Sans",sans-serif;font-size:13px;font-weight:500;text-transform:uppercase;letter-spacing:.06em;cursor:pointer;min-height:0}.hti-seg button.on{background:#141414;color:#fff}' +
      '.hti-ctl input[type=range]{-webkit-appearance:none;appearance:none;width:100%;height:2px;margin:12px 0;padding:0;border:0;background:#d9d9d6;box-shadow:none;outline:0}' +
      '.hti-ctl input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:20px;height:20px;border-radius:50%;background:#141414;border:3px solid #fff;box-shadow:0 0 0 1px #141414;cursor:pointer}' +
      '.hti-ctl input[type=range]::-moz-range-thumb{width:16px;height:16px;border-radius:50%;background:#141414;border:3px solid #fff;box-shadow:0 0 0 1px #141414;cursor:pointer}' +
      '.hti-sk{display:flex;gap:10px}.hti-sk button{width:30px;height:30px;min-height:0;padding:0;border-radius:50%;border:2px solid #fff;box-shadow:0 0 0 1px #ccc;cursor:pointer}.hti-sk button.on{box-shadow:0 0 0 2px #111}' +
      '.hti-cmp{display:flex;align-items:center;gap:8px}.hti-cmp input{width:90px;padding:8px 10px;border:1px solid #e4e4e1;border-radius:2px;font:inherit;font-size:16px}' +
      '.hti-hint{color:#7a7a75;font-size:12px;line-height:1.45;margin:0}' +
      '.hti-err{padding:40px;text-align:center;color:#777}' +
      '@media(max-width:760px){.hti-body{grid-template-columns:1fr}.hti-ov{padding:0;align-items:flex-end}.hti-box{max-height:92vh;max-height:92dvh;border-radius:10px 10px 0 0;-webkit-overflow-scrolling:touch}.hti-head{padding:14px 16px}.hti-x{font-size:30px;padding:6px 10px}.hti-ctl{gap:14px}}';
    document.head.appendChild(s);
  }

  function render() {
    var st = root.querySelector('.hti-stage');
    if (!info) return;
    var circ = state.circ / 10 * 10; // mm
    var w = wristWidthFromCirc(state.circ);
    var sk = SKINS[state.skin];
    var A = armPaths(w, state.female);
    var mmPerPx = data.diameter / info.casePx;
    var iw = info.w * mmPerPx, ih = info.h * mmPerPx;
    var ix = WX - info.axisX * mmPerPx, iy = CY - info.caseY * mmPerPx;
    var cmp = parseDiameter(state.compare);
    var ratio = data.diameter / w;
    var narrow = st.clientWidth < 560;
    // Uhr mittig; Ausschnitt so eng, dass rechts nicht mehr Hand zu sehen ist als vorher
    var vw = narrow ? 129 : 154, vh = narrow ? 103 : 106;
    var vb = (WX - vw / 2) + ' ' + (CY - vh / 2) + ' ' + vw + ' ' + vh;
    var fit = ratio < 0.62 ? 0 : ratio < 0.74 ? 1 : ratio < 0.84 ? 2 : 3;

    var svg =
      '<svg viewBox="' + vb + '" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="' + T.title + '">' +
      '<defs>' +
      '<linearGradient id="hti-sg" x1="0" y1="' + (CY - A.F / 2) + '" x2="0" y2="' + (CY + A.F / 2) + '" gradientUnits="userSpaceOnUse">' +
      '<stop offset="0" stop-color="' + sk.c + '"/><stop offset=".16" stop-color="' + sk.b + '"/><stop offset=".36" stop-color="' + sk.a + '"/>' +
      '<stop offset=".5" stop-color="' + sk.a + '"/><stop offset=".74" stop-color="' + sk.b + '"/><stop offset="1" stop-color="' + sk.c + '"/></linearGradient>' +
            // Band-Schattierung zum Rand des Handgelenks hin (Band läuft nach hinten)
      '<linearGradient id="hti-wrap" x1="0" y1="' + (CY - w / 2) + '" x2="0" y2="' + (CY + w / 2) + '" gradientUnits="userSpaceOnUse">' +
      '<stop offset="0" stop-color="#000" stop-opacity=".6"/><stop offset=".16" stop-color="#000" stop-opacity=".08"/><stop offset=".3" stop-color="#000" stop-opacity="0"/>' +
      '<stop offset=".7" stop-color="#000" stop-opacity="0"/><stop offset=".84" stop-color="#000" stop-opacity=".08"/><stop offset="1" stop-color="#000" stop-opacity=".6"/></linearGradient>' +
      '<clipPath id="hti-clip"><path d="' + A.outline + '"/></clipPath>' +
      '<mask id="hti-m" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="' + SCENE_W + '" height="' + SCENE_H + '"><image href="' + info.url + '" x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '"/></mask>' +
      '<filter id="hti-sh" x="-20%" y="-20%" width="140%" height="140%"><feGaussianBlur in="SourceAlpha" stdDeviation="1.4"/><feOffset dx="0.6" dy="1.4"/><feComponentTransfer><feFuncA type="linear" slope=".45"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge></filter>' +
      '<filter id="hti-soft"><feGaussianBlur stdDeviation="3"/></filter><filter id="hti-soft2"><feGaussianBlur stdDeviation="1"/></filter>' +
      '</defs>' +
      // Schatten des Arms
      '<path d="' + A.outline + '" fill="#000" opacity=".10" transform="translate(0,4)" filter="url(#hti-soft)"/>' +
      '<path d="' + A.outline + '" fill="url(#hti-sg)"/>' +
      // Knöchel/Handgelenkknochen andeuten
      '<ellipse cx="' + (WX - 8) + '" cy="' + (CY - w * 0.42) + '" rx="6" ry="2.6" fill="#fff" opacity=".12" filter="url(#hti-soft2)"/>' +
      '<g clip-path="url(#hti-clip)">' +
      '<g filter="url(#hti-sh)"><image href="' + info.url + '" x="' + ix + '" y="' + iy + '" width="' + iw + '" height="' + ih + '"/></g>' +
      '<rect x="0" y="0" width="' + SCENE_W + '" height="' + SCENE_H + '" fill="url(#hti-wrap)" mask="url(#hti-m)"/>' +
      '</g>' +
      (cmp ? '<circle cx="' + WX + '" cy="' + CY + '" r="' + cmp / 2 + '" fill="none" stroke="#c0392b" stroke-width=".7" stroke-dasharray="2 1.4"/>' +
        '<text x="' + (WX + cmp / 2 + 3) + '" y="' + (CY - cmp / 2 - 1) + '" font-size="' + (narrow ? 3.6 : 4) + '" fill="#c0392b" font-family="inherit">' + cmp + ' ' + T.mm + '</text>' : '') +
      '</svg>';
    st.innerHTML = svg + '<div class="hti-badge">' + T.case + ' ' + fmt(data.diameter) + ' ' + T.mm + ' · ' + T.fitLabel + ': <b>' + T.fit[fit] + '</b></div>';
    root.querySelector('.hti-circ-v').textContent = fmt(state.circ / 10) + ' cm';
  }
  function fmt(v) { return (Math.round(v * 10) / 10).toLocaleString(document.documentElement.lang || 'de'); }

  function open(opts) {
    data = opts;
    data.diameter = parseDiameter(opts.diameter);
    css();
    // Geschlecht kommt übersetzt aus global.Geschlecht (Damenuhr, Ladies' watch, Montre femme, Női óra …)
    state.female = !!(opts.gender && /dam|lad(y|ies)|women|femme|donna|señora|femin|női|жен|жін/i.test(opts.gender) && !/unisex|unissex|унисекс|унісекс/i.test(opts.gender));
    state.circ = state.female ? 155 : 175;
    root = el('div', { 'class': 'hti-ov', role: 'dialog', 'aria-modal': 'true' });
    root.innerHTML =
      '<div class="hti-box"><div class="hti-head"><h3>' + T.title + '<small>' + (opts.title || '') + '</small></h3>' +
      '<button class="hti-x" aria-label="' + T.close + '">&times;</button></div>' +
      '<div class="hti-body"><div class="hti-stage"><div class="hti-err">…</div></div>' +
      '<div class="hti-ctl">' +
      '<div class="hti-seg"><button data-g="0">' + T.men + '</button><button data-g="1">' + T.women + '</button></div>' +
      '<div><div class="hti-lbl"><span>' + T.wrist + '</span><span class="hti-circ-v"></span></div>' +
      '<input type="range" class="hti-circ" min="130" max="220" step="5"></div>' +
      '<div><div class="hti-lbl"><span>' + T.skin + '</span></div><div class="hti-sk">' +
      SKINS.map(function (s, i) { return '<button data-s="' + i + '" style="background:' + s.a + '" aria-label="' + T.skin + ' ' + (i + 1) + '"></button>'; }).join('') + '</div></div>' +
      '<div><div class="hti-lbl"><span>' + T.compare + '</span></div><div class="hti-cmp"><input type="number" inputmode="decimal" min="20" max="55" step="0.5" placeholder="40" class="hti-cmpi"> ' + T.mm + '</div></div>' +
      '<p class="hti-hint">' + T.hint + '</p>' +
      '</div></div></div>';
    document.body.appendChild(root);
    document.documentElement.style.overflow = 'hidden';

    var sync = function () {
      root.querySelectorAll('[data-g]').forEach(function (b) { b.classList.toggle('on', +b.dataset.g === (state.female ? 1 : 0)); });
      root.querySelectorAll('[data-s]').forEach(function (b) { b.classList.toggle('on', +b.dataset.s === state.skin); });
      root.querySelector('.hti-circ').value = state.circ;
      render();
    };
    root.addEventListener('click', function (e) {
      if (e.target === root || e.target.closest('.hti-x')) return close();
      var g = e.target.closest('[data-g]'); if (g) { state.female = g.dataset.g === '1'; state.circ = state.female ? 155 : 175; sync(); }
      var s = e.target.closest('[data-s]'); if (s) { state.skin = +s.dataset.s; sync(); }
    });
    root.querySelector('.hti-circ').addEventListener('input', function (e) { state.circ = +e.target.value; render(); });
    root.querySelector('.hti-cmpi').addEventListener('input', function (e) { state.compare = e.target.value; render(); });
    document.addEventListener('keydown', esc);
    window.addEventListener('resize', onResize);
    root.querySelector('.hti-box').scrollTop = 0;
    try { root.querySelector('.hti-x').focus({ preventScroll: true }); } catch (e) {}

    if (!data.diameter) { root.querySelector('.hti-stage').innerHTML = '<div class="hti-err">' + T.error + '</div>'; sync(); return; }
    info = null; sync();
    analyse(opts.image).then(function (r) { info = r; render(); track('tryon_open'); })
      .catch(function () { root.querySelector('.hti-stage').innerHTML = '<div class="hti-err">' + T.error + '</div>'; });
  }
  var rz;
  function onResize() { clearTimeout(rz); rz = setTimeout(function () { if (root) render(); }, 120); }
  function esc(e) { if (e.key === 'Escape') close(); }
  function close() {
    if (!root) return;
    root.remove(); root = null;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', esc);
    window.removeEventListener('resize', onResize);
  }
  function track(name) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('horando_' + name, { diameter: data.diameter }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'horando_' + name, diameter: data.diameter }); } catch (e) {}
  }

  /* ---------- Button automatisch einsetzen ---------- */
  function mount() {
    var cfg = document.getElementById('horando-tryon-data');
    if (!cfg) return;
    var o; try { o = JSON.parse(cfg.textContent); } catch (e) { return; }
    if (!parseDiameter(o.diameter) || !o.image) return;
    if (document.querySelector('.hti-btn')) return;
    css();
    var b = el('button', { type: 'button', 'class': 'hti-btn' },
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="5"/><path d="M9 7.5 9.6 3h4.8l.6 4.5M9 16.5 9.6 21h4.8l.6-4.5"/></svg>' +
      '<span class="hti-l">' + T.open + '</span><span class="hti-s">' + T.title + '</span>');
    b.addEventListener('click', function () { open(o); });
    // bevorzugt unten links im Hauptbild, sonst unter der Galerie bzw. dem Titel
    var stage = document.querySelector(o.anchor || '.product__main-photos');
    if (stage) {
      if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
      b.classList.add('hti-btn--overlay');
      stage.appendChild(b);
    } else {
      var g = document.querySelector('.product__photos') || document.querySelector('.product-single__title-row');
      if (g) g.insertAdjacentElement('afterend', b);
    }
  }

  window.HorandoTryOn = { open: open, analyse: analyse, mount: mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount); else mount();
})();
